"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawButton = exports.CSS = void 0;
var theme_1 = require("../theme");
var theme_palette_1 = require("../theme.palette");
var image_button_1 = require("./image.button");
exports.CSS = {
    container: 'c-DrawButton',
    isSelected: 'c-DrawButton--selected',
    solidBackground: 'c-DrawButton--solidBackground'
};
(0, theme_1.addStyles)((_a = {},
    _a[exports.CSS.container] = {
        'margin-bottom': theme_1.DefaultTheme.space(2),
        color: theme_1.DefaultTheme.font.color.primary,
        'background-color': theme_1.DefaultTheme.background.offWhite + '99',
        'box-shadow': theme_1.DefaultTheme.shadow.box.dp6,
        '&.mdl-button[disabled]': {
            'background-color': theme_1.DefaultTheme.background.offWhite + '99'
        },
        '&:hover': {
            'background-color': theme_palette_1.ColorPalette2022Branding.darkGray + '99',
            color: theme_1.DefaultTheme.font.color.white
        },
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        '&:focus:not(:active)': {
            border: "2px solid ".concat(theme_1.DefaultTheme.background.darkGrey),
            'background-color': theme_palette_1.ColorPalette2022Branding.darkGray + '99',
            color: theme_1.DefaultTheme.font.color.white
        }
    },
    _a[exports.CSS.solidBackground] = {
        '&:hover': {
            'background-color': theme_1.DefaultTheme.background.fadedGrey
        },
        '&:focus:not(:active)': {
            'background-color': theme_1.DefaultTheme.background.fadedGrey
        }
    },
    _a[exports.CSS.isSelected] = {
        'background-color': theme_1.DefaultTheme.color.accent,
        '&:focus:not(:active)': {
            'background-color': theme_1.DefaultTheme.color.accent
        },
        '&:focus:not(:hover)': {
            'background-color': theme_1.DefaultTheme.color.accent
        }
    },
    _a));
exports.DrawButton = {
    view: function (icon, ctx) {
        if (ctx === void 0) { ctx = {}; }
        if (ctx.className != null) {
            ctx.className = "".concat(ctx.className, " ").concat(exports.CSS.container);
        }
        else {
            ctx.className = exports.CSS.container;
        }
        if (ctx.solidBackground) {
            ctx.className += " ".concat(exports.CSS.solidBackground);
        }
        if (ctx.selected) {
            ctx.className = "".concat(ctx.className, " ").concat(exports.CSS.isSelected);
        }
        if (ctx.hidden) {
            ctx.className = "".concat(ctx.className, " hidden");
        }
        ctx.type = 'button';
        return image_button_1.ImageButton.view(icon, ctx);
    }
};
//# sourceMappingURL=draw.button.js.map